import { ArrowRightLeft, MessageSquare, Pencil, Plus, UserPlus } from 'lucide-react';
import type { ReactNode } from 'react';

import type { Notification } from '@tasks/contracts';

/** Иконка уведомления по типу события (docs/06 §2). */
export function notificationIcon(type: Notification['type']): ReactNode {
  switch (type) {
    case 'issue.created':
      return <Plus size={14} />;
    case 'issue.updated':
      return <Pencil size={14} />;
    case 'issue.transitioned':
      return <ArrowRightLeft size={14} />;
    case 'issue.assigned':
      return <UserPlus size={14} />;
    case 'comment.created':
      return <MessageSquare size={14} />;
    default:
      return null;
  }
}
